// Return unique keys of loads and custom fields in the orders
export function getLoadsCustomFieldsInOrders(rows: uui.domain.client.rm.FormattedData[]) {
  const uniqueKeys = {
    loads: new Set<string>(),
    executedLoads: new Set<string>(),
    customFields: new Set<string>(),
    executedCustomFields: new Set<string>(),
  }

  rows.forEach(row => {
    Object.keys(row.loads || {}).forEach(key => uniqueKeys.loads.add(`formattedData.loads.${key}`))
    Object.keys(row.executedLoads || {}).forEach(key =>
      uniqueKeys.executedLoads.add(`formattedData.executedLoads.${key}`),
    )
    Object.keys(row.customFields || {}).forEach(key =>
      uniqueKeys.customFields.add(`formattedData.customFields.${key}`),
    )
    Object.keys(row.executedCustomFields || {}).forEach(key =>
      uniqueKeys.executedCustomFields.add(`formattedData.executedCustomFields.${key}`),
    )
  })

  const loadsInOrders = Array.from(uniqueKeys.loads)
  const executedLoadsInOrders = Array.from(uniqueKeys.executedLoads)
  const customFieldInOrders = Array.from(uniqueKeys.customFields)
  const executedCustomFieldInOrders = Array.from(uniqueKeys.executedCustomFields)

  return {
    loadsInOrders,
    executedLoadsInOrders,
    customFieldInOrders,
    executedCustomFieldInOrders,
  }
}
